import { translate } from "app/filters/i18nFilter";
import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type SignalTemplate from "app/pages/sales-intelligence/sub-modules/signals/models/templates/SignalTemplate";
import type SignalFiltersViewProps from "app/pages/sales-intelligence/sub-modules/signals/models/view/SignalFiltersViewProps";

import {
    StyledTemplateLabel,
    StyledViewHeader,
} from "../../TrafficSignalFiltersView/styles";

type Props = Pick<SignalFiltersViewProps<SignalFilters>, "renderTemplateView"> & {
    onTemplateSelect(template: Readonly<SignalTemplate<SignalFilters>>): void;
};

const DROPDOWN_WIDTH = 352;
const DROPDOWN_HEIGHT = 300;

const EcommerceSignalFiltersViewHeader = (props: Props) => {
    return (
        <StyledViewHeader>
            <StyledTemplateLabel text={translate("si.signals.management.label.ecommerce")}>
                {props.renderTemplateView({
                    dropdownPopupWidth: DROPDOWN_WIDTH,
                    dropdownPopupHeight: DROPDOWN_HEIGHT,
                    hideTemplateDescriptionTooltip: true,
                    onSelect: props.onTemplateSelect,
                })}
            </StyledTemplateLabel>
        </StyledViewHeader>
    );
};

export default EcommerceSignalFiltersViewHeader;
